import axios, { AxiosResponse } from 'axios';

import { IZalozeniPostId } from 'services/specialniSluzby/ueZalozeni';

export interface IDodatekDFPUcetDltPut {
    rcma: string;
    qtet: number;
    ppn: boolean;
}

export interface IDodatekDFPUcetDlt {
    iducet: number;
    rcma: string;
    qtet: number;
    ppn: boolean;
}

export interface IDodatekDFPdlt {
    ucty: IDodatekDFPUcetDlt[];
    celkemcp: number;
}

export const dokumentUcetDfpDltGet = (id: number | string) => {
    return axios({
        method: 'GET',
        url: `/DOK/${id}/ucetdlt`
    }).then((resp: AxiosResponse<IDodatekDFPdlt>) => resp.data);
};

export const dokumentUcetDfpDltDeleteAll = (id: number | string) => {
    return axios({
        method: 'DELETE',
        url: `/DOK/${id}/ucetdlt`
    });
};

export const dokumentUcetDfpDltDelete = (id: number | string, iducet: number | string) => {
    return axios({
        method: 'DELETE',
        url: `/DOK/${id}/ucetdlt/${iducet}`
    });
};
export const dokumentUcetDfpDltPut = (id: number | string, iducet: number | string, data: IDodatekDFPUcetDltPut) => {
    return axios({
        method: 'PUT',
        url: `/DOK/${id}/ucetdlt/${iducet}`,
        data: data
    }).then((resp: AxiosResponse<IZalozeniPostId>) => resp.data);
};
export const dokumentUcetDfpDltPost = (id: number | string, data: IDodatekDFPUcetDltPut) => {
    return axios({
        method: 'POST',
        url: `/DOK/${id}/ucetdlt`,
        data: data
    }).then((resp: AxiosResponse<IZalozeniPostId>) => resp.data);
};
